import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarNotasDevolucoesCompraPendentesDashboard(api) {
    let parametros = {
      operacao: 'buscarNotasDevolucoesCompraPendentesDashboard'
    }

    let retorno = {};

    await api.santriGET('/rest/devolucaoCompra', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RDevolucaoCompra.js